import React, {useState, useEffect, useRef, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link } from 'react-router-dom';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';

import Select from 'react-select';

// import { EditorState, convertToRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
// import draftToHtml from 'draftjs-to-html';
import { history } from '../../_helpers';
import { fieldOptions_c,fieldOptions } from '../SignIn/data';

function QurationWrite() {
  const [quration, setQuration] = useState()
  const [state, actions] = useContext(UserContext);

  const [field, setField] = useState([])

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}

  const [title, setTitle] = useState()
  // const [content, setContet] = useState()
  
  const [editorState, setEditorState] = useState(EditorState.createEmpty());


  const inputFile = useRef(null) 
  const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);

  const [imgurl, setImgurl] = useState()

  let current_id = history.location.pathname.split('/')[3]

  const onEditorStateChange = (editorState) => {
    // editorState에 값 설정
    setEditorState(editorState);
  };
  function fetchQurationPost(){
    // console.log(field, job, fresh)
    if(current_id === "add") {
      fetch(state.awslink + "/api/quration/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title,
          "content": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
          "field": field,
          "photolink": imgurl || state.noimage
        })
      })
      .then(response => {
        return response.json()
        // if(response.status === 400){
        //   window.alert("Error!")
        // }
      })
      .then(json=>{
        console.log(json)
        history.push("/quration/single/" + json.id)
      })
    }

    else{
      fetch(state.awslink + "/api/quration/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": current_id,
          "title": title,
          "content": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
          "field": field,
          "photolink": imgurl || state.noimage
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        history.push("/quration/single/" + json.id)
      })
    }
  }


  
  const changeHandler = (event, whichimg) => {
    
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
    
    handleSubmission(event.target.files[0], whichimg)

	};

  const handleSubmission = (file, whichimg) => {
		const formData = new FormData();
    // console.log(whichimg)
    // if(whichimg === "logo")
		//   formData.append('file', selectedFile,  whichimg + '.' + selectedFile.name.split('.')[selectedFile.name.split('.').length-1]);
    // else
    //   formData.append('file', selectedFileMain,  whichimg + '.' + selectedFileMain.name.split('.')[selectedFileMain.name.split('.').length-1]);

    formData.append('file', file,  "quration_" + whichimg + '.' + file.name.split('.')[file.name.split('.').length-1]);  
		
    fetch(
			state.awslink + "/api/file/?quration" +"=true",
			{
				method: 'POST',
        headers: header,
				body: formData,
			}
		)
			.then((response) => response.json())
			.then((result) => {
				console.log('Success:', result);
        // setSelectedFile()
        // window.location.reload()
        setImgurl(result.file)
        setIsFilePicked()
			})
			.catch((error) => {
				console.error('Error:', error);
			});
    
	};
  const onButtonClick = (whichimg) => {
    // `current` points to the mounted file input element
      inputFile.current.click();
  };


  useEffect(()=>{
    async function fetchQurationGet(){
      const res =  fetch(state.awslink + "/api/quration/?id=" + current_id, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.content))) 
        console.log(convertFromRaw(JSON.parse(json.content)))
        console.log(parsed)
        setEditorState(parsed)
        setTitle(json.title)

        setImgurl(json.photolink)

        setField(json.field)

        setQuration(json)
      }
      )
    }
    if(current_id === "add")  console.log('add"')
    else fetchQurationGet();
  }, [])

  function handleDefault(index) {
    let tempObj=[];
    console.log(index)
    console.log(index.length)
    if(index !== undefined){
      if(index.length)
        index.map((item)=>{tempObj.push({value:item, label:item})})
    }
    else{
      console.log("undefined")
    }
    
    console.log(tempObj)
    return(tempObj)
  }

  const handleChange = (func) => e => {
    // console.log(func)
    // console.log(field)
    func(Array.isArray(e) ? e.map(x => x.value) : [])
  }

  
  // console.log(JSON.parse(JSON.stringify(editorState)))
  // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
  // console.log(draftToHtml(convertToRaw(JSON.parse(JSON.stringify(editorState)).getCurrentContent())))

  return(
    <Wrapper>
      <MidWrapper>
        <TitleBlock>
          <input value={title} onChange={(e)=>setTitle(e.target.value)}></input>
        </TitleBlock>
        
        {quration ? 
          <>
          {/* {console.log(fieldOptions.push({value:"커리어", label:"커리어"}))} */}
          FIELD
          <Select
            className="basic-single"
            defaultValue={handleDefault(field)}
            isSearchable={true}
            isMulti
            name="color"
            options={fieldOptions_c}
            onChange={handleChange(setField)}
          />
          </>
          :
          <>
          FIELD
          <Select
            className="basic-single"
            defaultValue={null}
            isSearchable={true}
            isMulti
            name="color"
            options={fieldOptions_c}
            onChange={handleChange(setField)}
          />
          </>
        }

        <MyBlock>
          <Editor
            // 에디터와 툴바 모두에 적용되는 클래스
            wrapperClassName="wrapper-class"
            // 에디터 주변에 적용된 클래스
            editorClassName="editor"
            // 툴바 주위에 적용된 클래스
            toolbarClassName="toolbar-class"
            // 툴바 설정
            toolbar={{
              // inDropdown: 해당 항목과 관련된 항목을 드롭다운으로 나타낼것인지
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: false },
            }} 
            placeholder="내용을 작성해주세요."
            // 한국어 설정
            localization={{
              locale: 'ko',
            }}
            // 초기값 설정
            editorState={editorState}
            // 에디터의 값이 변경될 때마다 onEditorStateChange 호출
            onEditorStateChange={onEditorStateChange}
          />
        </MyBlock>

        {title?
          <ImgWrapper>
            <img 
              src = {imgurl ? imgurl : "dummy"} 
              onError={(e)=> {
                e.target.src = state.noimage
              }}
              onClick={()=>onButtonClick(title)}
              style={{cursor: "pointer" }}
              alt={"quration-main"}
            />
            <input 
              type="file" 
              name="file" 
              ref={inputFile} 
              onChange={(e)=>{changeHandler(e, title); console.log("onChange")}} 
              style={{ display: "none" }}/>
            <div>대표사진</div>
          </ImgWrapper>
         
         :null
        }

        <button onClick={()=>{fetchQurationPost();}}>
          저장하기
          </button>
        {/* <button></button>
        <button></button> */}

      </MidWrapper>
    </Wrapper>   
  )
}

export default QurationWrite;


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 45px);
  margin-top: 45px;
  display: block;
  position: relative;
  background-color: white;
`

const MidWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  /* background-color: whitesmoke; */
  .basic-single{
    width: 80%;
    margin: auto;
  }
`

const TitleBlock = styled.div`
  display: flex;

  height: 45px;
  width: 80%;
  margin: 0 auto;
  /* margin-bottom: 4rem; */
  margin-top: 145px;
  /* border: 1px solid; */
  >input{
    width: 100%;
    border: 1px solid rgba(0,0,0,0.2) !important;
    :focus{
      outline: none;
    }
  }
`

const MyBlock = styled.div`
  /* margin-top: 100px; */
  .wrapper-class{
      width: 80%;
      margin: 0 auto;
      margin-bottom: 4rem;
  }
  .editor {
    height: 500px !important;
    border: 1px solid rgba(0,0,0,0.2) !important;
    padding: 5px !important;
    border-radius: 2px !important;
    background-color: white;
  }

  .rdw-editor-toolbar{
    border: 1px solid rgba(0,0,0,0.2) !important;
  }

  .rdw-dropdown-wrapper{
    /* z-index: 1; */
  }

  .rdw-text-align-dropdown{
    z-index: 0;
  }
  .rdw-list-dropdown{
    z-index: 0;
  }
  .DraftEditor-editorContainer{
    z-index: 0;
  }
`;

const ImgWrapper=styled.div`
  
  display: inline-flex;
  width: 300px;
  height: 250px;
  flex-direction: column;
  position: relative;
  >img{
    object-fit: scale-down;
    height: 100%;
    /* width: 80px;
    height: 80px;
    border-radius: 50px; */
  }
  >div{
    /* margin-top: 3px;
    margin-bottom: 3px; */

    position: absolute;
    bottom: 0;
    font-size: 0.9rem;
    opacity: .8;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    
  }

`